import React from "react";
import AnimatedContent from "./AnimatedContent";
import Email from "../assets/images/mail.svg";
import Instagram from "../assets/images/insta.svg";
import AppStore from "../assets/images/app-store.png";
import PlaySore from "../assets/images/play-store.jpg";

const StoreContent = () => {
  return (
    <div className="bottom-content">
      <AnimatedContent side="left">
        <div
          style={{
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            gap: 20,
            letterSpacing: "5.5px",
            wordSpacing: "4px",
            textAlign: "center"
          }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 5,
              alignItems: "center"
            }}>
            <h4 className="coming">Coming soon on</h4>
            <img className="store" src={AppStore} />
            <img className="store" src={PlaySore} />
          </div>
        </div>
      </AnimatedContent>
      <AnimatedContent side="right">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            gap: 15
          }}>
          <div className="contact-container">
            <div className="contact">
              <div>Contact:</div>
              <a href="tel:+919136716457" style={{ color: "#FFF", textDecoration: "none" }}>
                +91 9136716457
              </a>
            </div>
            <a
              href="https://www.instagram.com/starnex.in?igsh=MW12NzVpeTRsZDJlaw%3D%3D&utm_source=qr"
              target="_blank"
              rel="noopener noreferrer">
              <img className="social" src={Instagram} />
            </a>
            <a href="mailto:ask@starnex.co">
              <img className="social" src={Email} />
            </a>
          </div>
        </div>
      </AnimatedContent>
    </div>
  );
};

export default StoreContent;
